import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const UnauthorizedPage = () => {
    useDocumentTitle('Unauthorized');
    return (
        <ErrorPage
            code="401"
            title="Unauthorized"
            description="You have to login to view this resource.">
            <div className="unauthorized-icon text-center">
                <span className="fa-stack fa-5x mb-3">
                    <i className="fas fa-user fa-stack-1x text-muted"></i>
                    <i className="fas fa-ban fa-stack-2x text-primary"></i>
                </span>
            </div>
        </ErrorPage>
    );
};
